import { useEffect } from "react";
import "./AlertModal.css";

export default function AlertModal({
    isOpen,
    title,
    message,
    confirmText,
    cancelText,
    onConfirm,
    onCancel,
}) {
    useEffect(() => {
        if (!isOpen) return;

        const handleKeyDown = (e) => {
            if (e.key === "Escape") {
                onCancel?.();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, [isOpen, onCancel]);

    if (!isOpen) return null;

    return (
        <div
            className="alert-overlay"
            onClick={() => onCancel?.()}
        >
            <div
                className="alert-modal"
                onClick={(e) => e.stopPropagation()}
            >
                <h2 className="alert-title">{title}</h2>

                <p className="alert-message">{message}</p>

                <div className="alert-actions">
                    {cancelText && <button
                        className="alert-button secondary"
                        onClick={() => onCancel?.()}
                    >
                        {cancelText}
                    </button>}
                    {confirmText && <button
                        className="alert-button primary"
                        onClick={() => onConfirm?.()}
                    >
                        {confirmText}
                    </button>}

                </div>
            </div>
        </div>
    );
}